import React from 'react';
import { getText, TEXT_KEY } from 'shared/utils/localization';
import SFormInputs from 'shared/screens/LinkAccountForm/components/FormInputs';
import CopySelector from 'shared/utils/copySelector';
import ENVIRONMENT_VARIABLES from 'shared/utils/environmentVariables';
import getValuesArray from 'shared/utils/getValuesArray';
import { filterCustomProperties } from 'shared/utils/properties';
import AutoFormInput from '../../../../components/AutoFormInput';
import PropertySelector from '../../../../components/PropertySelector';
import { styles } from '../../styles';

const GENERIC_PROPERTY = 1;

export const DefaultFormInputs = ({ handleInputChange, formValues }) => {
  return (
    <SFormInputs
      render={args => {
        const { copys, userProperty, propertySelector } = args;

        const customPropertyOption =
          userProperty === GENERIC_PROPERTY
            ? null
            : propertySelector.filter(filterCustomProperties(userProperty)).map(property => ({
                value: property.propertyId,
                label: property.propertyName,
              }));

        return (
          <>
            <div style={styles.inputRow}>
              <AutoFormInput
                emitInput={handleInputChange('accountNumber')}
                value={formValues.accountNumber}
                label=""
                type="text"
                containerStyle={styles.inputContainer}
                customClassName="transparentInput"
                inputStyle={true}
                placeholder={`${CopySelector.getCopy(CopySelector.COPY_TYPES.WILDCARD, copys)} ${getText(
                  TEXT_KEY.NUMBER
                )}`}
                trimInput={true}
              />
              {ENVIRONMENT_VARIABLES.SHOW_PROPERTY_SELECTOR === 'true' && (
                <div style={{ width: '51%', pointerEvents: customPropertyOption ? 'none' : 'auto' }}>
                  <PropertySelector
                    onChangeDOB={handleInputChange('propertyId')}
                    selectedPropertyId={formValues.propertyId}
                    styles={styles.propertyIdContainer}
                    customOptions={customPropertyOption}
                    hidePlaceHolder={customPropertyOption ? true : false}
                  />
                </div>
              )}
            </div>
            <p style={styles.rowLabel}>{getText(TEXT_KEY.DATE_OF_BIRTH)}</p>
            <div style={styles.inputRow}>
              <AutoFormInput
                customClassName="transparentInput"
                emitInput={handleInputChange('year')}
                value={formValues.year}
                label=""
                type="text"
                placeholder={getText(TEXT_KEY.YEAR)}
                containerStyle={styles.inputContainer}
              />
              <AutoFormInput
                customClassName="transparentInput SelectBoxInput"
                emitInput={handleInputChange('month')}
                value={formValues.month}
                label=""
                type="dropdown"
                placeholder={getText(TEXT_KEY.MONTH)}
                options={getValuesArray(12)}
                containerStyle={styles.inputContainer}
              />
              <AutoFormInput
                customClassName="transparentInput SelectBoxInput"
                emitInput={handleInputChange('day')}
                value={formValues.day}
                label=""
                type="dropdown"
                options={getValuesArray(31)}
                placeholder={getText(TEXT_KEY.DAY)}
                containerStyle={styles.inputContainer}
              />
            </div>
          </>
        );
      }}
    />
  );
};

export default DefaultFormInputs;

